(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    /* Native #reviews anchor jumps don't scroll on the product page (checked live 2026-10-12),
     so the stars link scrolls the section into view itself; scroll-margin-top clears the header. */
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a.rating-wrapper--link') : null;
    if (!link) return;
    const target = document.getElementById('reviews');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', '#reviews');
  });
  } catch(e) { console.error(e); }
})();

})();
